import styled from "styled-components";

export const StyledAddProjectModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  & .input-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;

    & > div {
      width: 270px;
    }
  }
`;
